import { FC, ReactNode } from 'react'
import { Icons } from '@assets'
import Svg from '@components/svg'
import Row from '@components/row'
import Typography from '@components/typography'
import { StyleCard } from './style'
import Column from '@components/column'

interface FieldOverviewProps {
  title?: string
  icon?: keyof typeof Icons
  children?: ReactNode
  onClick?: () => void
}
const FieldOverview: FC<FieldOverviewProps> = ({
  title,
  icon,
  children,
  onClick,
}) => {
  return (
    <>
      <StyleCard>
        <Row alignItems="center" justifyContent="space-between">
          <Typography content={title} size={16} tc="primary" />
          <Column onClick={onClick}>
            <Svg svg={icon} color={'secondary'} />
          </Column>
        </Row>
        <Column styleColumn="margin-top:15px;">{!!children && children}</Column>
      </StyleCard>
    </>
  )
}

export default FieldOverview
